import { Col, Flex, notification, Row } from "antd";

import { useEffect } from "react";
import { useProjectsInfo } from "projects/queries";
import { ContractorDashboardProjectsCard } from "./contractor-dashboard-projects-card/ContractorDashboardProjectsCard";
import { ContractorDashboardDeficientProjectsCard } from "./contractor-dashboard-deficient-projects-card/ContractorDashboardDeficientProjectsCard";
import { SalesTargetTimePeriods } from "users/components";
import variables from "../../../../_variables.scss";
import { NotesList } from "notes/components";
import { useBoundStore } from "store";

export const ContractorDashboard = () => {
  const { currentOrganization } = useBoundStore();
  const {
    data: projectsInfo,
    isSuccess,
    error,
    refetch,
  } = useProjectsInfo(currentOrganization?.id);
  const [api, notificationContextHolder] = notification.useNotification();

  const onSalesTargetTimePeriodChange = () => {
    refetch();
  };

  useEffect(() => {
    if (error) {
      api.error({
        message: "Error",
        description: (error as Error)?.message,
      });
    }
  }, [error, api]);

  return (
    <Flex vertical gap={variables.largeGap}>
      {notificationContextHolder}
      <Flex>
        <SalesTargetTimePeriods
          name='sales-target-time-periods'
          onChange={onSalesTargetTimePeriodChange}
        />
      </Flex>
      <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 32 }} justify={"space-between"}>
        <Col span={17}>
          <ContractorDashboardProjectsCard
            loading={!isSuccess}
            hvacInstallationsBySubcontractor={projectsInfo?.hvacInstallationsBySubcontractor}
            lightingInstallationsBySubcontractor={projectsInfo?.lightingInstallationsBySubcontractor}
            outstandingContractorQuotes={projectsInfo?.outstandingContractorQuotes}
          />
        </Col>
        <Col span={7}>
          <NotesList title='My Project Notes' showCard />
        </Col>
      </Row>
      <ContractorDashboardDeficientProjectsCard
        loading={!isSuccess}
        deficientProjects={projectsInfo?.deficientProjects}
      />
    </Flex>
  );
};
